import React from 'react';
import { MarketplaceOrderListTemplate } from 'themes/modules/order/pages';
import { MarketplaceOrderListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new MarketplaceOrderListViewStore(rootStore), 'marketplaceOrderListViewStore')
class MarketplaceOrderList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <MarketplaceOrderListTemplate {...this.props} viewStore={this.props.marketplaceOrderListViewStore} />;
	}
}

export default MarketplaceOrderList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/MarketplaceOrderList.jsx